<template>
  <div class="profile">
    <div class="profile-container">
      <h1 class="profile-heading">Your Profile</h1>
      <section class="profile-section" v-if="userProfile">
        <h1 class="profile-label">Email</h1>
        <p class="profile-info">{{userProfile.email}}</p>
      </section>
      <div class="profile-subscription" :class="{'is-open': manageSubscription}">
        <button
          :class="{'is-open': manageSubscription}"
          type="button"
          name="button"
          class="drawer-button"
          @click="manageSubscription = !manageSubscription"
          data-test="manage-sub-button">
          <i class="chevron"></i>
          Manage Subscription
        </button>
        <div v-if="manageSubscription" class="profile-subscription__drawer">
          <subscribe :profile="true"/>
          <section class="profile-section">
            <aside class="profile-aside">Payments will show up on your statement as Cleverstack, Inc. If you have problems with your payment, please reach out to our payment provider at <a href="mailto:admin@fanfolk.com">admin@fanfolk.com</a>.</aside>
          </section>
        </div>
      </div>
      <div class="profile-settings">
        <section class="profile-settings__password">
          <ff-button v-if="!showPassword" data-test="change-password" :action="changePassword" :text="'Change Password'"/>
          <div class="" v-if="showPassword">
            <aside class="error" v-if="error">
              {{error}}
            </aside>
            <aside data-test="password-instructions" class="instructions" v-if="!password.one && !password.two">
              Please enter a New Password (and confirm) below.
            </aside>
            <ff-input data-test="password-input--one" type="password" v-model="password.one" :label="'New Password'"/>
            <ff-input data-test="password-input--two" type="password" v-model="password.two" :label="'Confirm Password'"/>
            <aside data-test="password-success" class="success" v-if="success && !error">
              {{success}}
            </aside>
            <aside data-test="no-match" class="instructions" v-if="password.one && password.two && !passwordsMatch">
              Ensure your passwords match before resetting.
            </aside>
            <ff-button :action="cancelPassword" :pattern="2" :text="'Cancel'"/>
            <ff-button data-test="change-password" v-if="passwordsMatch" :action="resetPassword" :text="'Reset Password'"/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Subscribe from '../_Shared/Subscribe'
import { auth } from '../../helpers/firebase'
import FFInput from '../DesignSystem/FFInput'
import FFButton from '../DesignSystem/FFButton'

export default {
  name: 'profile',
  props: {
  },
  components: {
    'subscribe': Subscribe,
    'ff-input': FFInput,
    'ff-button': FFButton
  },
  data () {
    return {
      userData: null,
      showPassword: false,
      error: null,
      success: null,
      manageSubscription: false,
      password: {
        one: null,
        two: null
      }
    }
  },
  methods: {
    changePassword () {
      this.showPassword = true
    },
    resetPassword () {
      let self = this
      this.userProfile.updatePassword(this.password.two).then(function() {
        self.success = 'Your password was successully changed.'
        setTimeout(() => {
          self.showPassword = false
        }, 3000)
      }).catch(function() {
        self.error = 'There was a problem changing your password.'
      })
    },
    cancelPassword () {
      this.showPassword = false
    }
  },
  created () {
  },
  computed: {
    userProfile () {
      return auth.currentUser
    },
    passwordsMatch () {
      return this.password.one && this.password.two && this.password.one === this.password.two
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .profile-heading {
    @include text('heading');
  }

  .profile-container {
    max-width: $maxWidth;
    margin: auto;
    padding-top: $unit-3*2;
  }

  .profile-settings {
    margin-bottom: $unit-3*2;

    &__password {
      margin-bottom: $unit-3;
    }
  }

  .profile-subscription {
    margin-bottom: $unit-3;
  }

  .drawer-button {
    @include button;
    font-size: $fontSize-normal;
    position: relative;
    margin-bottom: $unit-1;
    padding-left: 42px;

    .chevron {
      display: inline-block;
      width: 28px;
      height: 28px;
      background-image: url('../../assets/img/chevron-down.svg');
      background-position: left center;
      background-repeat: no-repeat;
      background-size: 22px;
      padding: 1rem;
      padding-bottom: 0px;
      transition: .1s ease-in-out all;
      position: absolute;
      top: 50%;
      left: $unit-1;
      transform: translate3d(0, -50%, 0) rotate(0deg);
      transform-origin: 11px;
    }

    &.is-open {
      .chevron {
        transform: translate3d(0, -50%, 0) rotate(180deg);
      }
    }
  }

  .profile-section {
    display: block;
    padding: $unit-2 0;
    margin-bottom: $unit-2;
  }

  .profile-label {
    @include caps;
  }

  .profile-info {
    font-size: $fontSize-medium;
  }

  .profile-aside {
    @include text('body');
    max-width: 32em;
  }

  .instructions,
  .success {
    @include success;
  }

</style>
